import React, { Component } from "react";
import {
  Button,
  Input,
  TreeSelect,
  Modal,
  Upload,
  message,
  Icon,
} from "antd";
const typeListItem = [
  {
    title: "请选择",
    value: "0",
    key: "0",
  },
  {
    title: "启用",
    value: "1",
    key: "1",
  },
  {
    title: "禁用",
    value: "2",
    key: "2",
  },
];
class AddIndexLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageUrl: "",
      typeListItem: [],
      typeKey: "0",
      visible: false,
      enabled: this.props.enabled,
    };
  }
  // 新增专栏
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  };
  onChange = () => {
    let enabled = this.state.enabled;
    this.setState({
      enabled: !enabled,
    });
  };
  render() {
    // 上传
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? "loading" : "plus"} />
        <div style={{ color: "purple" }}>点击上传</div>
      </div>
    );
    const { imageUrl } = this.state;

    return (
      <div>
        <Modal
          title="新增专题"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width="800px"
          bodyStyle={{ height: "500px" }}
          footer={null}
        >
          <div>
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "10px" }}>链接图标</div>
              <div style={{ marginLeft: "50px" }}>
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  beforeUpload={beforeUpload}
                  onChange={this.handleChange}
                >
                  {imageUrl ? (
                    <img
                      id="image"
                      src={imageUrl}
                      alt="avatar"
                      style={{ width: "100%" }}
                    />
                  ) : (
                      uploadButton
                    )}
                </Upload>
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>链接名称</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input placeholder="请输入链接名称(不超过6个字符)" />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>链接地址</div>
              <div style={{ marginLeft: "50px", width: "600px" }}>
                <Input placeholder="请输入链接地址(不超过100个字符)" />
              </div>
            </div>
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ marginLeft: "10px" }}>状态</div>
              <div style={{ marginLeft: "78px" }}>
                <TreeSelect
                  style={{ width: "200px" }}
                  value={this.state.typeKey}
                  treeData={typeListItem}
                  onChange={(value) => {
                    this.state.typeKey = value;
                    this.setState({});
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "50px",
              }}
            >
              <div>
                <Button type="primary" onClick={this.handleOk}>
                  保存
                </Button>
              </div>
              <div style={{ marginLeft: "20px" }}>
                <Button type="primary" onClick={this.handleCancel}>
                  取消
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
  // 上传
  handleChange = (info) => {
    if (info.file.status === "uploading") {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, (imageUrl) =>
        this.setState({
          imageUrl,
          loading: false,
        })
      );
    }
  };
}

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
}

export default AddIndexLink;
